import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RecommendationPlacement } from "~/features/search/models/RecommendationPlacement";
import { SET_RECOMMENDATION_PLACEMENT } from "../actionTypes";

export interface RecommendationPlacementState {
  placement?: RecommendationPlacement;
}

export const recommendationPlacementInitialState: RecommendationPlacementState = {};

export const recommendationPlacementSlice = createSlice({
  name: "recommendationPlacement",
  initialState: recommendationPlacementInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      SET_RECOMMENDATION_PLACEMENT,
      (state, action: PayloadAction<RecommendationPlacement | undefined>) => {
        state.placement = action.payload;
      },
    );
  },
});

export const recommendationPlacementReducer = recommendationPlacementSlice.reducer;
